import { HEADER_HEIGHT } from "const/layout";
// import HanaCardBanner from "assets/images/hana_banner.webp";
import HanaCardKTXBanner from "assets/images/hana_banner.png";

const HanaBgImage = () => {
  return (
    <div
      style={{
        position: "relative",
        top: `${HEADER_HEIGHT}px`,
        height: "calc(50vw)",
        width: "100%",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundImage: `url(${HanaCardKTXBanner})`,
        maxWidth: "480px",
        margin: "auto",
        backgroundPosition: "center",
        maxHeight: "260px",
      }}
    />
  );
};

export default HanaBgImage;
